/* jshint esversion: 6, -W097 */
/* globals require */
(function (angular) {
    'use strict';
    angular
        .module('enervee.fastTrack')
        .directive('fastTrackHeader', fastTrackHeader);

    /*
     Header of the fast track modal
     */
    function fastTrackHeader() {
        return {
            restrict: 'E',
            scope: {
                'onClose': '&'
            },
            controllerAs: 'vm',
            controller: FastTrackHeaderController,
            template: require('@app/components/fastTrack/header/headerView.html'),
        };

    }

    FastTrackHeaderController.$inject = ['$scope', 'UtilService'];
    function FastTrackHeaderController($scope, UtilService) {
        var vm = this;
        vm.onClose = $scope.onClose;
        vm.headerInfo = UtilService.getSiteSetting("fasttrack_modal_header_info");
    }

})(angular);